import { StyleSheet, View } from "react-native";
import { useCustomTheme } from "@luna-restaurant/ui";
import { MenuCardHeader } from "./MenuCardHeader";
export const MenuCard = ({ dayNumber, children, hasCheckmark, invalid, }) => {
    const { colors } = useCustomTheme();
    return (<View style={[
            styles.container,
            {
                backgroundColor: colors.background,
                borderColor: hasCheckmark || invalid === false
                    ? colors.border
                    : invalid
                        ? colors.danger
                        : colors.mutedBorder,
            },
            invalid && styles.containerInvalid,
        ]}>
      <MenuCardHeader dayNumber={dayNumber} hasCheckmark={hasCheckmark} invalid={invalid}/>

      {children}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        borderRadius: 6,
        padding: 8,
        marginBottom: 0,
        borderWidth: 1,
        gap: 8,
    },
    containerInvalid: {
        borderWidth: 3,
    },
});
//# sourceMappingURL=MenuCard.js.map